import { actions } from 'modules/authentication/actions'
import { actions as userRegistration, actions as user } from 'modules/user/actions'
import { actions as appSettings } from 'modules/appSettings/actions'
import { actions as location } from 'modules/location/actions'
import { actions as basket } from 'modules/basket/actions'
import { actions as products } from 'modules/products/actions'
import { actions as wallet } from 'modules/wallet/actions'
import { actions as orders } from 'modules/orders/actions'
import { actions as help } from 'modules/help/actions'

import { isEmpty } from 'utils/appUtils'
import {
    trackLoginMethod,
    trackUserRegistrationStart,
    trackUserRegistrationComplete,
    trackSetLocation,
    trackUserRegistrationSuccess,
    trackCartAddRemoveItem,
    trackCategoryPageViewed,
    trackSubCategoryPageViewed,
    trackProductDetailsPageViewed,
    trackCheckoutPageViewed,
    trackOrdersPageViewed,
    trackBasketPageViewed,
    trackPlaceOrderPageViewed,
    trackDynamicCategoryPageViewed,
    trackHelpPageViewed,
    trackCheckoutCompleted,
    trackCheckoutCancelled,
    trackPromoCodeEntered,
    trackFeedbackSubmitted,
    trackAppDownloadClicked,
    trackFeesExpanded,
    trackWebviewOpened,
    trackWebviewSessionstarted,
    addLoyaltyIdForWebsite,
    addSubscriptionSuperProp,
} from './helper'
import { store } from '../config/redux'

const events = {
    [actions.FACEBOOK_LOGIN_SUCCESS]: (response, state) => {
        trackLoginMethod('Facebook', true, response, state)
    },
    [actions.FACEBOOK_LOGIN_FAILED]: error => {
        trackLoginMethod('Facebook', false, error)
    },
    [actions.LOGIN_SUCCESS]: (response, state) => {
        trackLoginMethod('Email', true, response, state)
    },
    [actions.LOGIN_FAILED]: error => {
        trackLoginMethod('Email', false, error)
    },
    [userRegistration.REGISTER_USER_ACCOUNT]: () => {
        let location = window.location.pathname.slice(1)
        location += 'page'
        trackUserRegistrationStart(location)
    },
    [userRegistration.REGISTER_USER_ACCOUNT_FAILED]: (error, state) => {
        trackUserRegistrationComplete(false, error, state)
    },
    [products.APPLY_CATEGORY_FILTERS_SUCCESS]: () => {
        const location = window.location.pathname.split('').slice(1, 5).join('')
        const category = window.location.pathname.split('').slice(6).join('')
        location === 'shop' && trackCategoryPageViewed(location, category)
    },
    [products.GET_SUB_CATEGORY_FILTERS_SUCCESS]: () => {
        const state = store.getState()
        const { products } = state
        const location = window.location.pathname.split('').slice(1, 5).join('')
        location === 'shop' && trackSubCategoryPageViewed(location, products)
    },
    [products.GET_PRODUCT_DETAILS_SUCCESS]: state => {
        const location = window.location.pathname.split('').slice(1, 5).join('')
        location === ('shop' || 'home') && trackProductDetailsPageViewed(location, state)
    },
    [location.SET_ADDRESS]: (error, state) => {
        trackSetLocation(error, state)
    },
    [basket.PATCH_CART_SUCCESS]: (
        { basketResponse },
        state,
        { trackingData, mixpanelFlagForAi, mixpanelFlagForSearch }
    ) => {
        if (trackingData) {
            trackCartAddRemoveItem(
                trackingData.operation,
                trackingData.item,
                basketResponse,
                state.basket.toJS(),
                mixpanelFlagForAi,
                mixpanelFlagForSearch
            )
        }
    },
    [basket.TRACKING_SUGGESTIVE_ITEMS]: response => {
        const state = store.getState()
        const basket = state.basket.toJS()
        const location = window.location.pathname.slice(1)
        trackBasketPageViewed(location, basket, response)
    },
    [wallet.GET_SAVED_CARDS_SUCCESS]: () => {
        let location = window.location.pathname.slice(1)
        const state = store.getState()
        const basket = state.basket.toJS()
        const wallet = state.wallet.toJS()
        location += 'page'
        location === 'checkoutpage' &&
            basket !== null &&
            wallet !== null &&
            trackCheckoutPageViewed(location, basket, wallet)
    },
    [basket.PLACE_ORDER_VIEWED]: () => {
        let location = window.location.pathname.slice(1)
        const state = store.getState()
        const basket = state.basket.toJS()
        const wallet = state.wallet.toJS()
        location += 'page'
        location === 'checkoutpage' &&
            basket.checkoutResponse !== null &&
            wallet !== null &&
            trackPlaceOrderPageViewed(location, basket, wallet)
    },
    [products.APPLY_SUB_CATEGORY_FILTERS_SUCCESS]: () => {
        const location = window.location.pathname.split('').slice(1, 5).join('')
        const state = store.getState()
        const { products } = state
        location === 'home' && trackDynamicCategoryPageViewed(location, products)
    },
    [help.GET_HELP_DATA_SUCCESS]: () => {
        const location = window.location.pathname.split('').slice(1, 5).join('')
        location === 'user' && trackHelpPageViewed(location)
    },
    [basket.PROMO_CODE_RESULT]: response => {
        const location = window.location.pathname.slice(1)
        location === 'checkout' && response && trackPromoCodeEntered(location, response)
    },
    [basket.PLACE_ORDER_SUCCESS]: response => {
        let location = window.location.pathname.slice(1)
        location += 'page'
        location === 'checkoutpage' && trackCheckoutCompleted(location, response)
    },

    [basket.CALL_CANCEL_ORDER]: () => {
        trackCheckoutCancelled()
    },

    [basket.FEES_EXPANDED]: () => {
        const state = store.getState()
        const basket = state.basket.toJS()
        const fees = basket && basket.basketResponse && basket.basketResponse.basketSummary
        const location = getCurrentPage()
        fees && trackFeesExpanded(location, fees)
    },
    [orders.SUBMIT_FEEDBACK_SUCCESS]: response => {
        const location = window.location.pathname.slice(1)
        trackFeedbackSubmitted(location, response)
    },
    [help.GET_THE_APP_CLICKED]: () => {
        const location = getCurrentPage()
        trackAppDownloadClicked(location)
    },
    [appSettings.SET_IS_APP]: () => {
        trackWebviewOpened()
        trackWebviewSessionstarted()
    },
    [user.SET_USER_PROFILE]: () => {
        const state = store.getState()
        const { user } = state
        const profile = user.toJS().getUserProfileResponse?.profile
        profile && !isEmpty(profile?.loyalty_id) && addLoyaltyIdForWebsite(profile)
        profile &&
            !isEmpty(profile?.subscriptions) &&
            addSubscriptionSuperProp(profile?.subscriptions?.[0])
    },
}

export const getCurrentPage = () => {
    const location = window.location.pathname
    switch (location) {
        case location === '':
            return 'landing page'
        case location.slice(1) === 'home':
            return 'home page'
        case location.slice(1) === 'shop':
            return 'shop page'
        case location.slice(1) === 'deals':
            return 'deals page'
        case location.split('').slice(1, 5).join('') === 'shop':
            return 'category page'
        case location.split('').slice(1, 5).join('') === 'home':
            return 'dynamic category page'
        case location.slice(1) === 'order-status':
            return 'order status page'
        case location.slice(1) === 'order-details':
            return 'order details page'
        case location.slice(1) === 'checkout':
            return 'checkout page'
        default:
            return location
    }
}

export const analyticsMiddleware = store => next => action => {
    const state = store.getState()

    if (events[action.type]) {
        events[action.type](action.payload, state, action)
    }

    return next(action)
}
